import createSupabaseStore from './supabase-table-store'

export default projectId => createSupabaseStore(
  async (set, supabase, payload) => {
    const {data} = await supabase
      .from('projects_view')
      .select('*')
      .eq('project_id', projectId)
    ;

    set(data && data.length ? data[0] : null);
  },
  'projects'
)